export const noIPM = "__no_ipm__";
export const noCommand = "__no_command__";
